//
// ExportFileFormat.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var ExportFileFormat = {
    CSV:0,
    TSV:1,
    XLSX:2
};
export default ExportFileFormat;
